var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJewelBoxYellow = function SvgJewelBoxYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "jewel-box--yellow_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".jewel-box--yellow_svg__st0{fill:#fed607}.jewel-box--yellow_svg__st1,.jewel-box--yellow_svg__st3{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}.jewel-box--yellow_svg__st3{fill:#fed607}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.6 54H20.4l-1.5-10c0-9 42.2-9 42.2 0l-1.5 10z",
    className: "jewel-box--yellow_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.7 43.9 1.4 9.3h37.8l1.3-9.3c0-.8-.5-1.5-1.5-2.3-1-.8-2.6-1.4-4.5-2-3.9-1.1-9-1.7-14.3-1.7s-10.4.6-14.3 1.7c-1.9.6-3.5 1.2-4.5 2s-1.4 1.6-1.4 2.3zm40-3.5c1.3.9 2.1 2.1 2.1 3.6v.1l-1.4 10c-.1.4-.4.7-.8.7H20.4c-.4 0-.7-.3-.8-.7l-1.5-10V44c0-1.5.9-2.7 2.1-3.6 1.3-.9 3-1.7 5-2.2 4-1.2 9.4-1.7 14.7-1.7s10.7.6 14.7 1.7c2.1.5 3.8 1.3 5.1 2.2z",
    className: "jewel-box--yellow_svg__st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2 58.4H22.8l-3.9-15.6h42.2l-3.9 15.6z",
    className: "jewel-box--yellow_svg__st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2 42.3c.2-.2.4-.3.6-.3H61c.2 0 .5.1.6.3.2.2.2.4.1.7L58 58.6c-.1.4-.4.6-.8.6H22.8c-.4 0-.7-.2-.8-.6L18.1 43c-.1-.2 0-.5.1-.7zm1.7 1.3 3.5 14h33.2l3.5-14H19.9z",
    className: "jewel-box--yellow_svg__st1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61 51.4H18.9v15.2H61V51.4z",
    className: "jewel-box--yellow_svg__st0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 51.4c0-.4.4-.8.8-.8H61c.4 0 .8.4.8.8v15.2c0 .4-.4.8-.8.8H18.9c-.4 0-.8-.4-.8-.8V51.4zm1.6.8v13.6h40.6V52.2H19.7z",
    className: "jewel-box--yellow_svg__st1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8 57.2c-2.4 0-4.2-1.9-4.2-4.2v-1h8.6v1c-.1 2.3-2 4.2-4.4 4.2z",
    className: "jewel-box--yellow_svg__st0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7 51.9c0-.4.4-.8.8-.8h8.6c.4 0 .8.4.8.8v1c0 2.8-2.3 5-5.1 5-2.9 0-5-2.3-5-5v-1zm1.6.8v.3c0 1.9 1.5 3.4 3.4 3.4 2 0 3.5-1.6 3.5-3.4v-.2h-6.9z",
    className: "jewel-box--yellow_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.4 22.7H32.8L26 31.4l13.6 15.1 13.6-15.1-6.8-8.7z",
    style: {
      fill: "#0b1b34"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2 22.2c.2-.2.4-.3.6-.3h13.6c.2 0 .5.1.6.3l6.8 8.7c.2.3.2.7 0 1L40.2 47.1c-.2.2-.4.3-.6.3-.2 0-.4-.1-.6-.3L25.4 32c-.3-.3-.3-.7 0-1l6.8-8.8zm1 1.3L27 31.4l12.6 14 12.6-14-6.2-7.9H33.2z",
    className: "jewel-box--yellow_svg__st1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2 32.2H26v-1.6h27.2v1.6z",
    className: "jewel-box--yellow_svg__st1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8 46.1 32 22.9l1.5-.5 6 20.5 6-20.5 1.5.5L40.2 46c-.1.3-.4.6-.8.6s-.5-.2-.6-.5z",
    className: "jewel-box--yellow_svg__st1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6 21.9c.3 0 .6.2.7.5l3.4 8.7-1.5.6-2.6-6.8-2.7 6.8-1.5-.6 3.4-8.7c.2-.3.5-.5.8-.5z",
    className: "jewel-box--yellow_svg__st1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m29.2 21-3-3 1.1-1.1 3 3-1.1 1.1zM24.1 27.3l-4-.9.3-1.6 4 .9-.3 1.6zM54 25.7l4.1-.9.3 1.6-4.1.9-.3-1.6zM48.2 19.9l3-3 1.1 1.1-3 3-1.1-1.1zM38.4 18.2v-4.8H40v4.8h-1.6z",
    className: "jewel-box--yellow_svg__st3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 66.6H19v-7.4l7.4 7.4z",
    className: "jewel-box--yellow_svg__st0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 58.4c.3-.1.6-.1.9.2L27 66c.2.2.3.6.2.9-.1.3-.4.5-.7.5H19c-.4 0-.8-.4-.8-.8v-7.4c0-.4.2-.7.5-.8zm1.1 2.7v4.7h4.6l-4.6-4.7z",
    className: "jewel-box--yellow_svg__st1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7 66.6h7.4v-7.4l-7.4 7.4z",
    className: "jewel-box--yellow_svg__st0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4 58.4c.3.1.5.4.5.7v7.4c0 .4-.4.8-.8.8h-7.4c-.3 0-.6-.2-.7-.5-.1-.3-.1-.6.2-.9l7.4-7.4c.2-.2.5-.2.8-.1zm-5.8 7.4h4.7v-4.7l-4.7 4.7z",
    className: "jewel-box--yellow_svg__st1"
  })));
};
export default SvgJewelBoxYellow;